import React from 'react';
import { CTAButton } from './CTAButton';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-6 md:pt-8 pb-12 px-4 text-center max-w-5xl mx-auto" data-id="element-73">
      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-3xl md:text-5xl font-black text-brand-text mb-4 leading-[1.1] tracking-tight max-w-3xl mx-auto text-balance" data-id="element-74">
        Resuelve un año entero de clases de Música en solo{' '}
        <span className="italic text-brand-red" data-id="element-75">5 minutos</span>
      </motion.h1>

      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.1
    }} className="text-sm md:text-base text-brand-gray max-w-2xl mx-auto mb-6" data-id="element-76">
        Más de 2.000 docentes ya dejaron de improvisar. Llega a cada clase con
        todo listo para enseñar, inspirar y transformar.
      </motion.p>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.2
    }} className="relative w-full max-w-2xl mx-auto mb-8" data-id="element-77">
        <img src="https://cdn.magicpatterns.com/uploads/rndV7KKUmVVUsveDG9Ax9a/ChatGPT_Image_6_jul_2026,_10_08_01-Photoroom.png" alt="Pack Música Lista: 12 tomos imprimibles, monitor, tablet y celular con las clases de música listas para usar." className="w-full h-auto object-contain" data-id="element-78" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3
    }} data-id="element-79">
        <CTAButton onClick={scrollToPricing} className="mb-6" data-id="element-80">
          QUIERO EL PACK MÚSICA LISTA
        </CTAButton>
        <p className="text-sm text-brand-gray font-medium flex items-center justify-center gap-2" data-id="element-81">
          Descarga inmediata &middot; Sin suscripción &middot; Acceso de por
          vida &middot; Garantía 7 días
        </p>
      </motion.div>
    </section>;
}